export const defaultIssue1 = () => {
    return {
        id: 1,
        prod_id:"prod_Qt315Uy3XNBdnO",
        name: "ISSUE ONE: WONDER WOMEN",
        price: 6
    }
}
export const defaultIssue2 = () => {
    return {
        id: 2,
        prod_id:"prod_Qt31g8e76j4Ooh",
        name: "ISSUE TWO: ENVIRONMENT",
        price: 12
    }
}
export const defaultIssue3 = () => {
    return {
        id: 3,
        prod_id:"prod_Qt31YfjsDtS55K",
        name: "ISSUE THREE: YOUTH",
        price: 12
    }
}
export const defaultIssue4 = () => {
    return {
        id: 4,
        prod_id:"prod_Qt32XJ6nHwfovm",
        name: "ISSUE FOUR: LGBTQIA+",
        price: 12
    }
}
export const defaultIssue5 = () => {
    return {
        id: 5,
        prod_id:"prod_Qt32hhBGjpjGe9",
        name: "ISSUE FIVE: HUMAN",
        price: 12
    }
}
export const defaultIssue6 = () => {
    return {
        id: 6,
        prod_id:"prod_Qt32Hj3UHNYbK3",
        name: "ISSUE SIX: BIPOC",
        price: 12
    }
}
export const defaultIssue7 = () => {
    return {
        id: 7,
        prod_id:"prod_Qt32A6mxNUZF4d",
        name: "ISSUE SEVEN: SUSTAINABILITY",
        price: 12
    }
}
export const defaultIssue8 = () => {
    return {
        id: 8,
        prod_id:"prod_Qt32rs10Pd0sjD",
        name: "ISSUE EIGHT: UNITED NATION",
        price: 12
    }
}
export const defaultIssue9 = () => {
    return {
        id: 9,
        prod_id:"prod_Qt32Q6SwTgIq1K",
        name: "ISSUE NINE: IDENTITY",
        price: 12
    }
}
export const defaultIssue10 = () => {
    return {
        id: 10,
        prod_id:"prod_Qt32RMMUBFJmEL",
        name: "ISSUE TEN: MUSIC",
        price: 15
    }
}
export const defaultIssue11 = () => {
    return {
        id: 11,
        prod_id:"prod_Qt32hC6BzI4m0x",
        name: "ISSUE ELEVEN: EXPRESSION",
        price: 15
    }
}
export const defaultIssue12 = () => {
    return {
        id: 12,
        prod_id:"prod_Qt3c3AktZMZSAF",
        name: "ISSUE TWELVE: THE NEW ORDER",
        price: 15
    }
}
export default {
    totalPay: "",
    library: [],
    issue1: defaultIssue1(),
    issue2: defaultIssue2(),
    issue3: defaultIssue3(),
    issue4: defaultIssue4(),
    issue5: defaultIssue5(),
    issue6: defaultIssue6(),
    issue7: defaultIssue7(),
    issue8: defaultIssue8(),
    issue9: defaultIssue9(),
    issue10: defaultIssue10(),
    issue11: defaultIssue11(),
    issue12: defaultIssue12(),
    packageId: ""
}